import { useRef } from 'react';
import { motion } from 'framer-motion';
import { Circular3DGallery } from '../components/ui/Circular3DGallery';

export function Gallery() {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={containerRef} className="pt-32 px-6 md:px-12 min-h-screen">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="max-w-7xl mx-auto"
            >
                <div className="text-center mb-16">
                    <h1 className="text-5xl md:text-7xl font-bold mb-4 text-white">Visual <span className="text-emerald-500">Archive</span></h1>
                    <p className="text-gray-400 max-w-lg mx-auto">
                        A collection of interfaces, experiments, and digital art.
                    </p>
                </div>

                <Circular3DGallery />

            </motion.div>
        </div>
    );
}
